export default {
  SYSTEM_ADMIN: [
    {
      icon: "",
      title: "赛事审批",
      path: "/management/admin/game",
      children: [
        // { icon: "", title: "中央本级", path: "/management/admin/game/centerlevel" },
        // { icon: "", title: "转移支付", path: "/management/admin/game/tranpay" },
        // { icon: "", title: "2022年转移支付(提前下达部分)", path: "/management/admin/game/2022tranpay" },
        { icon: "", title: "全国青少年体育赛事备案", path: "/management/admin/game/record" }
      ]
    },
    {
      icon: "",
      title: "综合查询",
      path: "/management/admin/search"
    },
    {
      icon: "",
      title: "其他管理",
      path: "/management/admin/setup",
      children: [
        { icon: "", title: "赛事名录", path: "/management/admin/setup/gamebase" },
        { icon: "", title: "人才培养基地", path: "/management/admin/setup/addressbase" }
      ]
    },
    {
      icon: "",
      title: "重置用户密码",
      path: "/management/admin/resetPassword"
    }
  ],
  QSS: [
    {
      icon: "",
      title: "赛事审批",
      path: "/management/qss/game",
      children: [
        // { icon: "", title: "中央本级", path: "/management/qss/game/centerlevel" },
        // { icon: "", title: "转移支付", path: "/management/qss/game/tranpay" },
        // { icon: "", title: "2022年转移支付(提前下达部分)", path: "/management/qss/game/2022tranpay" },
        { icon: "", title: "全国青少年体育赛事备案", path: "/management/qss/game/record" }
      ]
    },
    {
      icon: "",
      title: "综合查询",
      path: "/management/qss/search"
    }
    // {
    //   icon: "",
    //   title: "其他管理",
    //   path: "/management/qss/setup",
    //   children: [
    //     { icon: "", title: "赛事名录", path: "/management/qss/setup/gamebase" },
    //     { icon: "", title: "人才培养基地", path: "/management/qss/setup/addressbase" }
    //   ]
    // }
  ],
  SPORT_CENTER: [
    {
      icon: "",
      title: "赛事管理",
      path: "/management/sportcenter",
      children: [
        { icon: "", title: "U系列赛事", path: "/management/sportcenter/game" },
        { icon: "", title: "精英训练营", path: "/management/sportcenter/traincamp" },
        { icon: "", title: "体教融合专项赛事", path: "/management/sportcenter/campus" },
        { icon: "", title: "全国青少年体育赛事备案", path: "/management/sportcenter/record" }
        // { icon: "", title: "俱乐部比赛", path: "/management/sportcenter/club" }
      ]
    }
  ],
  PROVINCE: [
    {
      icon: "",
      title: "赛事管理",
      path: "/management/province",
      children: [
        { icon: "", title: "U系列赛事活动", path: "/management/province/activities" },
        { icon: "", title: "教练员培训", path: "/management/province/coache" },
        { icon: "", title: "高水平体育后备人才基地", path: "/management/province/reserve" },
        { icon: "", title: "青训中心", path: "/management/province/youthTraining" },
        { icon: "", title: "青少年足球", path: "/management/province/school" },
        { icon: "", title: "2022年转移支付(提前下达部分)", path: "/management/province/tranpay" }
        // { icon: "", title: "足球", path: "/management/province/football" }
        // { icon: "", title: "本单位下属操作员", path: "/management/province/operator" }
      ]
    }
  ],
  PROVINCE_PRINCIPAL: [
    {
      icon: "",
      title: "赛事管理",
      path: "/management/province",
      children: [
        { icon: "", title: "U系列赛事活动", path: "/management/province/activities" },
        { icon: "", title: "教练员培训", path: "/management/province/coache" },
        { icon: "", title: "高水平体育后备人才基地", path: "/management/province/reserve" },
        { icon: "", title: "青训中心", path: "/management/province/youthTraining" },
        { icon: "", title: "青少年足球", path: "/management/province/school" },
        { icon: "", title: "2022年转移支付(提前下达部分)", path: "/management/province/tranpay" }
        // { icon: "", title: "足球", path: "/management/province/football" }
      ]
    }
  ]
};
